import React from 'react';
import Navigation from 'bridge-global-nav';
import Runtime from '@get-bridge/learn-legacy-shared/dist/core/Runtime';
import { object, string } from 'prop-types';
import { setAtlasLocale } from '@get-bridge/atlas';
import AuthStore from '@get-bridge/learn-legacy-shared/dist/stores/AuthStore';
import ProfileStore from '@get-bridge/learn-legacy-shared/dist/stores/ProfileStore';
import classnames from 'classnames';

function getCurrentLocale(user) {
  const locales = [
    user && user.locale,
    Runtime.get('DOMAIN.config.locale'),
    'en'
  ]
  return locales.find(l => !!l);
}

function isNavDisabled(pathname, appInfo) {
  const disabledNavPaths = appInfo.disabledNavPaths || [];
  return disabledNavPaths.find(path => pathname.match(path))
}

function GlobalNav({ appInfo, pathname }) {
  const user = AuthStore.getCurrentUserProfileData();

  setAtlasLocale(getCurrentLocale(user));

  if (isNavDisabled(pathname, appInfo)) {
    return null;
  }

  const theme = ProfileStore.getActiveTheme(
    pathname,
    user && user.theme,
    false
  );
  const classes = classnames('global-navigation', theme);

  return (
    <div className={classes} data-qa="global-navigation">
      <Navigation
        path={pathname}
        currentRouteName={pathname}
        location={window.location}
        user={user} />
    </div>
  );
}

GlobalNav.propTypes = {
  appInfo: object.isRequired,
  pathname: string.isRequired
}

export default GlobalNav



// WEBPACK FOOTER //
// ./jsapp/learnRuntime/GlobalNav/Component.js